import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

export type LoaderPropsType = {
  loaderType?: 'basic' | 'complex' | 'section' | 'kitty' | 'section-large' | 'button'
  visible: boolean
  style?: React.CSSProperties
  color?: string
  message?: string
}

const Loader: React.FC<LoaderPropsType> = ({ loaderType = 'basic', visible = true, color, style, message }) => {
  if (visible) {
    return (
      <div
        className={cn('loader', { [`loader--${loaderType}`]: !!loaderType, [`loader--${color}`]: !!color })}
        style={style}
      >
        <span className="loader__spinner" />
        <span className="loader__message">{message}</span>
      </div>
    )
  }
  return null
}

export default Loader
